import { render, staticRenderFns } from "./istekislem.vue?vue&type=template&id=ae967e28&"
import script from "./istekislem.vue?vue&type=script&lang=js&"
export * from "./istekislem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports